import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "../../../../utils/Constants";
import { handleServerValidations } from "../../../../utils/commonfunction";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import CustomPagination from "../../common/custompagination";
import { List, Delete } from "../../services/reportPrice.services";

const ReportPriceTable = () => {
    const { t } = useTranslation();
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [statsupdate, setStatusUpdate] = useState(false);
    const [datalength, setDataLength] = useState("");
    const [itemperpage] = useState(10);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true);
    const [globalsearch, setGlobalSearch] = useState("");

    const breadcrumbs = [
        { title: t("link_dashboard"), url: "/admin/dashboard" },
        { title: "Report Prices", url: "" },
    ];

    useEffect(() => {
        const getData = setTimeout(() => {
            setLoader(true);
            const formData = new FormData();
            formData.append("page", params.pgno || 1);
            formData.append("per_page", itemperpage);
            formData.append("global_search", globalsearch);

            List(formData)
                .then((data) => {
                    setDataLength(data?.data?.total_records || 0);
                    setList(data?.data?.list || []);
                    setPage(data?.data?.page || 1);
                    setLoader(false);
                })
                .catch((error) => {
                    console.log("error ====> ", error);
                    setLoader(false);
                });
        }, 300);
        return () => clearTimeout(getData);
    }, [location, statsupdate, globalsearch, itemperpage, params.pgno]);

    function Deletefunction(id) {
        Swal.fire({
            customClass: "swal-wide",
            title: t("msg_are_you_sure"),
            text: t("you_not_be_able_to_revert_this"),
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: t("btn_cancel"),
            confirmButtonColor: "#403fad",
            cancelButtonColor: "#f1388b",
            confirmButtonText: t("btn_yes_delete"),
        }).then((result) => {
            if (result.isConfirmed) {
                Delete({ id: id })
                    .then((response) => {
                        setStatusUpdate(!statsupdate);
                        if (response.status || response.success) {
                            Swal.fire({
                                icon: "success",
                                text: response.message,
                                ...SWAL_SETTINGS,
                            });
                        } else {
                            Swal.fire({
                                icon: "error",
                                text: handleServerValidations(response),
                                ...SWAL_SETTINGS,
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("deleteError", error);
                    });
            }
        });
    }

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="animation_fade">
                <div className="card custom-card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h6 className="main-content-label">Report Prices</h6>
                            <div className="d-flex align-items-center">
                                <div className="form-group mb-0 me-3">
                                    <div className="form-group mb-0 rangepicker_container filter_design">
                                        <i className="fa fa-search calender_icon"></i>
                                        <input
                                            type="search"
                                            className="form-control"
                                            value={globalsearch}
                                            placeholder="Search report title..."
                                            onChange={(e) => setGlobalSearch(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <button
                                    className="btn ripple btn-main-primary signbtn mr-2"
                                    onClick={() => navigate(`/admin/report-price/add`)}
                                >
                                    {t("btn_add_new")}
                                </button>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                                <thead>
                                    <tr>
                                        <th className="position-relative select_head">
                                            <span>{t("list_heading_sno")}</span>
                                        </th>
                                        <th>Report Title</th>
                                        <th>About</th>
                                        <th>Duration</th>
                                        <th>Price (INR)</th>
                                        <th>Price (USD)</th>
                                        <th className="action_head">{t("list_heading_action")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader && datalength > 0 ? (
                                        <tr>
                                            <td colSpan={7}>
                                                <Loader />
                                            </td>
                                        </tr>
                                    ) : (
                                        <>
                                            {list.length ? (
                                                list.map((row, i) => (
                                                    <tr key={i}>
                                                        <td>
                                                            {row
                                                                ? (page - 1) * itemperpage + i + 1
                                                                : null}
                                                        </td>
                                                        <td>{row?.Report?.title || "N/A"}</td>
                                                        <td>{row?.about || "N/A"}</td>
                                                        <td>{row?.duration || "N/A"}</td>
                                                        <td>{row?.price_inr || "0"}</td>
                                                        <td>{row?.price_usd || "0"}</td>
                                                        <td>
                                                            <div className="d-flex">
                                                                <button
                                                                    className="btn ripple btn-success mlAction"
                                                                    onClick={() =>
                                                                        navigate(
                                                                            `/admin/report-price/edit/${row.id || row._id}`
                                                                        )
                                                                    }
                                                                >
                                                                    <i className="fa fa-edit me-1"></i>
                                                                    {t("btn_edit")}
                                                                </button>
                                                                <button
                                                                    className="btn ripple btn-secondary mlAction"
                                                                    onClick={() => Deletefunction(row?.id || row?._id)}
                                                                >
                                                                    <i className="fa fa-trash me-1"></i>
                                                                    {t("btn_delete")}
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={7} className="text-center">
                                                        {t("msg_no_records")}
                                                    </td>
                                                </tr>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="mt-3">
                            <b>
                                {t("msg_total_records")} : {datalength ? datalength : "0"}
                            </b>
                        </div>
                        {datalength && datalength > 0 ? (
                            <CustomPagination
                                datalength={datalength}
                                itemperpage={itemperpage}
                                currentPage={page}
                                setPage={setPage}
                                pageRoute={[
                                    {
                                        name: "Report Price",
                                        path: "/admin/report-price/list",
                                    },
                                ]}
                            />
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReportPriceTable;
